<template>
    <div class="post" @click="click">
        <LinkHover
            :type="'router-link'"
            :to="$trl({
                name: 'Project',
                params: {
                    slug: post.customslug || post.slug,
                    locale: $route.params.locale
                }
            })"
            :class="['link-hover']"
        >
            <span class="default">
                <span class="caption">
                    {{ post.name +  (country ? ',' : '')}}<br/>
                    <span v-if="country">{{country.name}}</span>
                </span>
                <span class="tags" v-if="description != ''">
                    {{ description }}
                </span>
            </span>
            <template v-slot:hover>
                <span class="hover">
                    <div
                        class="picture"
                        :style="{ backgroundImage: 'url(' + post.image.url + ')' }"
                    >
                        <img
                            :src="post.image.url"
                            :alt="post.image.alt"
                            :title="post.image.title"
                            class="seo-image"
                        />
                    </div>
                    <div class="black"></div>
                    <div class="bg-cross-animated"></div>
                    <span class="caption">
                        {{ post.name +  (country ? ',' : '')}}<br/>
                        <span v-if="country">{{country.name}}</span>
                    </span>
                    <span class="tags" v-if="description != ''">
                        {{ description }}
                    </span>
                </span>
            </template>
        </LinkHover>
    </div>
</template>
<script>

import LinkHover from '@/components/animation/LinkHover'
export default {
    components: {
        LinkHover
    },
    props: {
        post: {
            type: Object,
            default() {}
        }
    },
    computed: {
        related() {
            const res = (this.$parent.$parent.page.type === 'project') ?
                this.$parent.$parent.page.related_posts
                    .filter(item => {
                        return this.post.related_posts.find(_ => _ === item.id)
                    }) : [{ name: this.$parent.$parent.page.name }]
            return res
        },
        country() {
            return [].find.call(this.post.related_posts, _ => _.type === 'country')
        },
        description() {
            return this.post.baseline ? this.post.baseline : '' ;
        }
    },
    methods: {
        click() {
            window.location.reload()
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.post
    border: 1px solid #e0e1e3
    box-sizing: border-box
    // margin-left: -1px
    // margin-top: -1px
    // @include media-breakpoint-down($lg)
    //     border-top: 1px solid #e0e1e3
    //     border-right: 1px solid #e0e1e3
    //     border-left: 1px solid #e0e1e3
    //     border-bottom: none
    font-size: 0
    // &:last-child
    //     border-right: 1px solid #e0e1e3
    //     @include media-breakpoint-down($lg)
    //         border-bottom: 1px solid #e0e1e3
    @media print
        border: none
        margin-left: 0
        margin-top: 0
        a:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal

.link-hover
    text-decoration: none
    @include media-breakpoint-down($lg)
        width: 100%
.default, .hover
    display: block
    width: 460px
    min-height: 568px
    display: flex
    flex-direction: column
    padding-left: (100% * 60px / 450px)
    padding-bottom: (100% * 55px / 450px)
    padding-right: (100% * 55px / 450px)
    flex: 1
    display: flex
    @include media-breakpoint-down($lg)
        width: 100%
        height: 75.75vw
        min-height: 0
    @media print
        height: auto
        width: auto
        padding-left: 0
        padding-right: 0
        padding-bottom: 0
        padding-top: 0
        min-height: 0
        margin-top: .3cm
        margin-bottom: .3cm
.picture
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: -3
    background-size: cover
    background-position: 50% 50%
.black
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: #636772
    opacity: 0.2
    z-index: -2
.caption
    display: flex
    flex: 1
    flex-direction: column
    justify-content: center
    font-size: 28px
    color: #636772
    font-weight: 500
    line-height: 1.2
    min-height: 2.4em
    @include media-breakpoint-down($sm)
        font-size: 17px
.tags
    color: #ff2b2a
    font-size: 17px
    font-weight: 500
    @include media-breakpoint-down($sm)
        font-size: 12px
.tag
    &:before
        content: ", "
    &:first-child:before
        display: none
.hover
    // background-color: #ff2b2a
    background-position: 50% 50%
    background-repeat: no-repeat
    background-size: cover
    .caption, .tags
        color: #ffffff
.bg-cross-animated
    pointer-events: none
</style>
